<script setup>
import apiDriveCommande from "@/services/http/api-drive/client/commande";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";

definePageMeta({
  middleware: "authenticated"
});

const { trackPage } = useTrackingPage();
const { layout } = storeToRefs(useContextStore());
const { throwIfAxiosError } = useAxiosHelper();

const commandes = ref([]);

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
});

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/mon-compte/toutes-mes-commandes/${layout.value}.vue`
    ]
  );
});

const { data, error } = await useAsyncData((app) =>
  app.$apiDrive.use(apiDriveCommande).commandes()
);
throwIfAxiosError(error);

commandes.value = data.value.data;

if (data.value.meta.has_archive) {
  const { data: dataArchives } = await useAsyncData((app) =>
    app.$apiDrive.use(apiDriveCommande).commandes({ archive: 1 })
  );
  commandes.value = commandes.value.concat(dataArchives.value.data);
}
</script>

<template>
  <component
    :is="component"
    :commandes="commandes"
  />
</template>
